import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { Routes, RouterModule } from '@angular/router';
import { PopupModule } from 'ng2-opd-popup';

import { AppComponent } from './app.component';
import { ConfirmPageComponent } from './confirm-page/confirm-page.component';
import { PrivacyPageComponent } from './privacy-page/privacy-page.component';

// Import library module
import { NgxSpinnerModule } from "ngx-spinner";
import { ModalModule } from 'ng2-modal';

const appRoutes: Routes = [
  { path: '', component: PrivacyPageComponent },
  { path: 'double-opt-in', component: ConfirmPageComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    ConfirmPageComponent,
    PrivacyPageComponent
],
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    HttpClientModule,
    ModalModule,
    // PopupModule.forRoot(),
    RouterModule.forRoot(appRoutes),
    NgxSpinnerModule
  ],
  exports: [RouterModule],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/andrea/Documents/Projects/SW40/landing-portale-privacy/src/app/app.module.ts